module.exports = __webpack_public_path__ + "static/media/niyitanga_rushaki4.6fa9d150.jpg";